module.exports = __webpack_public_path__ + "img/RORBPJS40074.bb44b1b1.png";